/** Commands supported by public/toolfare/toolfare.mjs (Node 18+).
 * Keep the published MCP resource: the product hostname is not its OAuth audience.
 */
function shellQuote(value: string): string {
  return "'" + value.replace(/'/g, "'\\''") + "'"
}

export function isToolfareCli(
  product: 'soku' | 'toolfare',
  pathname: string,
): boolean {
  return (
    product === 'toolfare' ||
    pathname === '/connect' ||
    pathname.startsWith('/connect/')
  )
}

export function toolfareSetup(origin: string, endpoint: string | null) {
  const skillUrl = `${origin}/connect/skill.md`
  const install = `mkdir -p ~/.local/bin
curl -fsSL ${shellQuote(`${origin}/toolfare/toolfare.mjs`)} -o ~/.local/bin/toolfare
chmod +x ~/.local/bin/toolfare
export PATH="$HOME/.local/bin:$PATH"`
  return {
    skillUrl,
    prompt: `Read ${skillUrl} and install the toolfare skill for this agent, then follow it to install the CLI and sign in, pausing for my browser approval.`,
    install,
    login: endpoint ? `export TOOLFARE_MCP_URL=${shellQuote(endpoint)}\ntoolfare login` : null,
    verify: 'toolfare whoami\ntoolfare balance',
  }
}

export const TOOLFARE_CLI_ACCOUNT_NOTE =
  'The toolfare CLI signs in through MCP OAuth. Its approval appears with your connected AI apps; Remove access revokes that grant. Run toolfare logout on this machine to revoke access and remove local credentials. If remote revocation fails, remove the approval here too.'

export function toolfareClientReason(hasCli: boolean): string {
  return hasCli
    ? 'Use the MCP connection in your AI app, or run the toolfare CLI in its terminal. Both use browser approval, discover capabilities and quote paid calls before they run.'
    : 'This app connects over MCP. Add the connection and approve access in your browser.'
}
